// @flow

import * as React from "react";
import cx from "classnames";

import styles from "./Text.scss";

type TextProps = {
  additionalClasses: string,
  variant: "caption" | "primary",
  children: React.Node
};

const Text = ({ children, additionalClasses = "", variant = "caption" }: TextProps) => (
  <span
    className={cx(
      { [styles.caption]: variant === "caption", [styles.primary]: variant === "primary" },
      additionalClasses
    )}
  >
    {children}
  </span>
);

export default Text;
